// extracted by mini-css-extract-plugin
export default {"adWrapper":"_ads_adWrapper__oG+Z8","img":"_ads_img__XnAXe","indicatorContentWrp":"_ads_indicatorContentWrp__WWCNR"};